import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';

import { inventoryFormSchema } from '@/_pages/settings/inventory-kits/shared/schemas/inventory';

import { defaultValues } from './model';

export function useFormDefinition() {
  return useForm({
    resolver: zodResolver(inventoryFormSchema),
    defaultValues,
  });
}
